import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import type { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import type { CreanceRow } from "@/lib/creance.api";
import { formatDate, formatMoney, getCreanceInvoiceLabel, parseAmount } from "./creance-formatters";
import { CreanceStatusBadge } from "./components/CreanceStatusBadge";

export function createCreanceColumns(
  onSelect: (creance: CreanceRow) => void,
): ColumnDef<CreanceRow, any>[] {
  return [
    {
      id: "invoice",
      header: "Facture",
      cell: ({ row }) => (
        <Link
          to={`/invoices/${row.original.invoiceId}`}
          onClick={(event) => event.stopPropagation()}
          className="text-[12px] font-medium text-brand-gold-dark hover:underline"
        >
          {getCreanceInvoiceLabel(row.original)}
        </Link>
      ),
    },
    {
      accessorKey: "partyName",
      header: "Client",
      cell: ({ row }) => <span className="text-[12px] text-body">{row.original.partyName}</span>,
    },
    {
      id: "installment",
      header: "Échéance",
      cell: ({ row }) => (
        <span className="text-[12px] text-muted-foreground">
          #{row.original.sequence} - {formatDate(row.original.expectedDate)}
        </span>
      ),
    },
    {
      accessorKey: "principalDue",
      header: "Principal dû",
      meta: { align: "right" },
      cell: ({ row }) => (
        <span className="text-[12px] text-body">
          {formatMoney(parseAmount(row.original.principalDue))}
        </span>
      ),
    },
    {
      accessorKey: "penaltyDue",
      header: "Pénalité due",
      meta: { align: "right" },
      cell: ({ row }) => {
        const penalty = parseAmount(row.original.penaltyDue);
        return penalty > 0 ? (
          <span className="text-[12px] font-medium text-danger-text">{formatMoney(penalty)}</span>
        ) : (
          <span className="text-[12px] text-muted-foreground">-</span>
        );
      },
    },
    {
      accessorKey: "isOverdue",
      header: "Statut",
      cell: ({ row }) => <CreanceStatusBadge creance={row.original} />,
    },
    {
      id: "detail",
      header: "",
      meta: { align: "right" },
      cell: ({ row }) => (
        <Button
          variant="ghost"
          size="icon"
          title="Voir le détail"
          onClick={(event) => {
            event.stopPropagation();
            onSelect(row.original);
          }}
        >
          <Eye size={13} />
        </Button>
      ),
    },
  ];
}
